import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => (
  <div style={{ overflowX: "hidden", position: "relative" }}>
    <Header />
    <div>{children}</div>
    <Footer />
  </div>
);

export default Layout;
